'use strict';
module.exports = require('../../full/instance/find-index');
